<template>
    <div class="privacy-message__container">
        <div class="privacy-message__accept-terms redesign-checkbox redesign-checkbox--margin-right" :id="fullFormIdentifier + '-privacy-terms-errors'">
            <input class="redesign-checkbox__input" type="checkbox" name="privacy-terms" :id="fullFormIdentifier + '-privacy-terms'" value="Y" data-validate="checkbox" data-validate-message="You must agree to our terms &amp; conditions" :data-error-target="fullFormIdentifier + '-privacy-terms-errors'" />
            <label class="redesign-checkbox__label redesign-checkbox__label--grid" :for="fullFormIdentifier + '-privacy-terms'">
                <span class="redesign-checkbox__span"></span>
                <div>
                    I have read and accept the <a class="privacy-message__link" :href="privacyTermsLink" target="_blank">Terms and Conditions</a>
                </div>
            </label>
        </div>
        <p class="privacy-message__p">
            For more information about Stellantis &You UK, your rights and how your personal data is processed by us, please read our full <a class="privacy-message__link" href="/privacy-policy" target="_blank">Privacy Policy</a>
        </p>
        <h3 class="privacy-message__h3">Marketing Consent</h3>
        <p class="privacy-message__p">
            We'd love to keep you updated with exclusive offers and events from Stellantis &You UK. If you would like to opt into our marketing communications, please indicate your preference below. You can unsubscribe at any time by contacting us.
        </p>
        <div class="marketing-options__container" id="marketing-options__container">
            <div class="redesign-radio">
                <input class="redesign-radio__input" type="radio" v-model="marketingPreference" name="marketing_preference" :id="fullFormIdentifier + '-marketing-email-sms'" value="Email and SMS" data-validate="radio" data-validate-message="Please let us know if you would like to hear from us by email or SMS" data-error-target="marketing-options__container" autocomplete="off" />
                <label class="redesign-radio__label" :for="fullFormIdentifier + '-marketing-email-sms'"><span class="redesign-radio__span"></span>Yes (Email & SMS)</label>
            </div>
            <div class="redesign-radio">
                <input class="redesign-radio__input" type="radio" v-model="marketingPreference" name="marketing_preference" :id="fullFormIdentifier + '-marketing-email'" value="Email" autocomplete="off" />
                <label class="redesign-radio__label" :for="fullFormIdentifier + '-marketing-email'"><span class="redesign-radio__span"></span>Yes (Email)</label>
            </div>
            <div class="redesign-radio">
                <input class="redesign-radio__input" type="radio" v-model="marketingPreference" name="marketing_preference" :id="fullFormIdentifier + '-marketing-sms'" value="SMS" autocomplete="off" />
                <label class="redesign-radio__label" :for="fullFormIdentifier + '-marketing-sms'"><span class="redesign-radio__span"></span>Yes (SMS)</label>
            </div>
            <div class="redesign-radio">
                <input class="redesign-radio__input" type="radio" v-model="marketingPreference" name="marketing_preference" :id="fullFormIdentifier + '-marketing-none'" value="None" autocomplete="off" />
                <label class="redesign-radio__label" :for="fullFormIdentifier + '-marketing-none'"><span class="redesign-radio__span"></span>No</label>
            </div>
        </div>
        <p class="privacy-message__p privacy-message__p--re-captcha">
            This site is protected by reCAPTCHA and the Google
            <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.
        </p>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        formIdentifier: {
            type: String,
            default: "form",
        },
        privacyTermsLink: {
            type: String,
            default: "/terms-and-conditions",
        },
    },
    data() {
        return {
            marketingPreference: "",
        };
    },
    computed: {
        fullFormIdentifier() {
            return this.formIdentifier + "-" + this._uid;
        },
    },
};
</script>